/*
 * Auto-add free gift (Cuff Fold Beanie) 1-for-1 with every qualifying
 * board in the cart, for the "2627 PRE-ORDER BONUS" Buy X Get Y discount.
 *
 * 2 boards from the qualifying collection -> 2 free beanies auto-added.
 * Remove a board -> the beanie count drops back down to match.
 *
 * IMPORTANT: This script only ADDS/ADJUSTS the beanie quantity in the
 * cart. It does NOT make it free — the price still comes entirely from
 * your "2627 PRE-ORDER BONUS" automatic discount in Shopify admin.
 * For more than 1 beanie to actually go free, that discount's
 * "Set a maximum number of uses per order" must be unchecked (or raised
 * well above 1) — otherwise Shopify will only discount the first beanie
 * and charge full price for the rest.
 *
 * Also make sure FREE_GIFT_VARIANT_ID below is one of the variant(s)
 * selected under that discount's "Customer gets" step (recommended:
 * select all 4 Cuff Fold Beanie variants there so this always discounts
 * correctly no matter which variant ID is used here).
 */
(function () {
  var COLLECTION_HANDLE = 'winter-2627'; // qualifying collection ("Customer buys")
  var FREE_GIFT_VARIANT_ID = 55653445697704; // Cuff Fold Beanie - Black/Pure Snow
  var FREE_GIFT_PROPERTY_KEY = '_free_gift';
  var FREE_GIFT_PROPERTY_VALUE = '2627-preorder-bonus';
  var GIFT_TO_BOARD_RATIO = 1; // 1 beanie per qualifying board
  var MAX_FREE_GIFTS = 10; // safety ceiling, keep in sync with the discount's per-order cap

  var qualifyingProductIds = null;
  var isProcessing = false;
  var needsRecheck = false;

  function log() {
    if (window.location.search.indexOf('debug_gift') !== -1) {
      console.log.apply(console, ['[free-gift]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  async function getQualifyingProductIds() {
    if (qualifyingProductIds) return qualifyingProductIds;
    try {
      var res = await fetch('/collections/' + COLLECTION_HANDLE + '/products.json?limit=250');
      var data = await res.json();
      qualifyingProductIds = (data.products || []).map(function (p) { return p.id; });
      log('qualifying product ids', qualifyingProductIds);
    } catch (e) {
      qualifyingProductIds = [];
      log('failed to load qualifying collection', e);
    }
    return qualifyingProductIds;
  }

  async function checkAndSyncGift() {
    if (isProcessing) {
      needsRecheck = true;
      return;
    }
    isProcessing = true;
    try {
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var qualifyingIds = await getQualifyingProductIds();

      var qualifyingQty = cart.items.reduce(function (sum, item) {
        return qualifyingIds.indexOf(item.product_id) !== -1 ? sum + item.quantity : sum;
      }, 0);

      var desiredGiftQty = Math.min(qualifyingQty * GIFT_TO_BOARD_RATIO, MAX_FREE_GIFTS);

      var giftLine = cart.items.find(function (item) {
        return item.properties && item.properties[FREE_GIFT_PROPERTY_KEY] === FREE_GIFT_PROPERTY_VALUE;
      });
      var currentGiftQty = giftLine ? giftLine.quantity : 0;

      log('qualifyingQty', qualifyingQty, 'desiredGiftQty', desiredGiftQty, 'currentGiftQty', currentGiftQty);

      if (desiredGiftQty === currentGiftQty) {
        // nothing to do
      } else if (!giftLine && desiredGiftQty > 0) {
        log('adding gift line, qty', desiredGiftQty);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: FREE_GIFT_VARIANT_ID,
                quantity: desiredGiftQty,
                properties: { _free_gift: FREE_GIFT_PROPERTY_VALUE }
              }
            ]
          })
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } else if (giftLine) {
        log('adjusting gift line', giftLine.key, 'to qty', desiredGiftQty);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftLine.key, quantity: desiredGiftQty })
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (e) {
      log('sync error', e);
    } finally {
      isProcessing = false;
      if (needsRecheck) {
        needsRecheck = false;
        setTimeout(checkAndSyncGift, 200);
      }
    }
  }

  // Run once on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndSyncGift);
  } else {
    checkAndSyncGift();
  }

  // Re-check after any AJAX cart mutation (add/change/update), from this
  // theme's own cart drawer/page or any app that touches the cart.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    var body = (arguments[1] && arguments[1].body) || '';
    var isOurOwnCall = /_free_gift/.test(body);
    var isCartMutation = /\/cart\/(add|change|update)/.test(urlStr) && !isOurOwnCall;
    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartMutation) {
        setTimeout(checkAndSyncGift, 300);
      }
      return response;
    });
  };

  // Fallback for themes that submit the add-to-cart form normally
  // (full page reload) rather than via AJAX/fetch.
  document.addEventListener('cart:updated', checkAndSyncGift);
})();